import { jwtDecode } from 'jwt-decode'; // Named import

// ✅ Get just the username from the token
export const getUsernameFromToken = (tokenArg = null) => {
  const token = tokenArg || localStorage.getItem("authToken");
  if (!token) return null;

  try {
    const decodedToken = jwtDecode(token);

    const currentTime = Math.floor(Date.now() / 1000);
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      console.warn("Token has expired");
      return null;
    }

    // Adjust depending on your token payload
    return decodedToken.username || decodedToken.name || decodedToken.sub || null;
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

// ✅ Get full user details from the token
export const getUserFromToken = (tokenArg = null) => {
  const token = tokenArg || localStorage.getItem("authToken");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);

    const currentTime = Math.floor(Date.now() / 1000);
    if (decoded.exp && decoded.exp < currentTime) {
      console.warn("Token has expired");
      return null;
    }

    return {
      userId: decoded.userId || decoded._id || decoded.id || "",
      username: decoded.username || decoded.name || decoded.sub || "",
      role: decoded.role || "",
      rank: decoded.rank || "",
      branch: decoded.branch || "",
      subBranch: decoded.subBranch || "",
      unitBranch: decoded.unitBranch || "",
      unit: decoded.unit || "",
      serviceNumber: decoded.serviceNumber || ""
    };
  } catch (error) {
    console.error("Error decoding user token", error);
    return null;
  }
};
